import { PRICE_VIEW } from "./b2c-b2b-toggler-helper-2.js";
import { generateHash } from "./generate-hash.js";

const initRegisterForm = () => {
  const triggerRegisterBtn = document.querySelector(
    ".protected .links__create-acc"
  );
  const triggerLoginBtn = document.querySelector(".protected .links__back");
  const registerForm = document.querySelector(".protected .register");
  const loginForm = document.querySelector(".protected .login");

  if (!triggerLoginBtn || !registerForm || !loginForm) {
    return;
  }

  triggerRegisterBtn.addEventListener("click", () => {
    toggleForms();
  });

  triggerLoginBtn.addEventListener("click", () => {
    toggleForms();
  });

  const toggleForms = () => {
    const isHidden = registerForm.classList.contains("hidden");
    registerForm.classList.toggle("hidden", !isHidden);
    loginForm.classList.toggle("hidden", isHidden);
  };
};

document.addEventListener("DOMContentLoaded", () => {
  initRegisterForm();

  localStorage.removeItem(PRICE_VIEW);

  const protectedFormEl = document.querySelector(".protected__form");

  if (protectedFormEl) {
    const isRegistered =
      localStorage.getItem("isRegistered") ||
      protectedFormEl.hasAttribute("data-unverified");

    protectedFormEl.classList.toggle("registered", isRegistered);
  }
});

export const setPasswordHash = async (email, password) => {
  const valueWithSalt = password + email;
  const hash = await generateHash(valueWithSalt);
  const expiryDate = new Date();
  const day = 7 * 24 * 60 * 60 * 1000;

  expiryDate.setTime(expiryDate.getTime() + day);
  document.cookie = `_token=${hash}; expires=${expiryDate.toUTCString()}; path=/; secure;`;
  sessionStorage.setItem("isRedirectToHome", true);

  return hash;
};
